import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function Newsletter() {
  return <section id="zenith" className="py-24 bg-[#0A0A0A]" data-id="element-175">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-176">
        <div className="relative rounded-2xl overflow-hidden" data-id="element-177">
          {/* Background Image */}
          <div className="absolute inset-0" data-id="element-178">
            <img src="https://images.unsplash.com/photo-1511512578047-dfb367046420?w=1600&q=80" alt="Gaming Setup" className="w-full h-full object-cover" data-id="element-179" />
            <div className="absolute inset-0 bg-[#0A0A0A]/90 mix-blend-multiply" data-id="element-180" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/80 to-transparent" data-id="element-181" />
          </div>

          <div className="relative z-10 px-8 py-16 md:p-20 max-w-3xl" data-id="element-182">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-183">
              <span className="inline-block py-1 px-3 border border-[#C9A962] text-[#C9A962] text-xs font-mono tracking-widest uppercase mb-6" data-id="element-184">
                Zenith Tier Access
              </span>
              <h2 className="text-4xl md:text-5xl font-serif text-[#F5F5F0] mb-6" data-id="element-185">
                Join the Collector's Circle
              </h2>
              <p className="text-lg text-[#F5F5F0]/70 mb-8 max-w-xl" data-id="element-186">
                Subscribe to receive notifications about upcoming limited drops,
                exclusive Zenith Tier releases, and curator insights.
              </p>

              <form className="flex flex-col sm:flex-row gap-4 max-w-md" data-id="element-187">
                <input type="email" placeholder="Enter your email address" className="flex-1 bg-[#F5F5F0]/5 border border-[#F5F5F0]/10 text-[#F5F5F0] px-6 py-3 focus:outline-none focus:border-[#C9A962] transition-colors placeholder:text-[#F5F5F0]/30" data-id="element-188" />
                <Button data-id="element-189">Subscribe</Button>
              </form>
              <p className="mt-4 text-xs text-[#F5F5F0]/40" data-id="element-190">
                By subscribing, you agree to our Privacy Policy. No spam, just
                rare loot.
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}